import { logout, signInWithGoogle, signInWithMicrosoft } from '../auth';

import { Box, Button, Select, SpaceBetween } from '@cloudscape-design/components';
import { useEffect, useState } from 'react';
import { RiGoogleLine } from 'react-icons/ri';
import { TiVendorMicrosoft } from 'react-icons/ti';
import { useNavigate } from 'react-router-dom';
import { fetchItems } from '../api/generic';
import { useAuthContext } from '../contexts/AuthContext';
import { useRefresh } from '../contexts/RefreshContext';
import Tenant from '../models/Tenant';

const Loginout = () => {
  const { refresh } = useRefresh();
  const { currentUser, userObject, tenant, changeTenant, setDepartment } = useAuthContext();
  const navigate = useNavigate();

  const [tenants, setTenants] = useState<Tenant[]>();

  const fetchTenants = async () => {
    const ts = await fetchItems<Tenant>('tenant');
    setTenants(ts);
  };

  useEffect(() => {
    fetchTenants();
  }, []);

  return (
    <div style={{ paddingLeft: 28 }}>
      {currentUser ? (
        <Button
          onClick={() => {
            logout();
            navigate('/');
          }}
          variant="inline-link"
        >
          Logout
        </Button>
      ) : (
        <SpaceBetween size="m" direction="vertical">
          <Button onClick={signInWithGoogle} variant="inline-link" iconSvg={<RiGoogleLine />}>
            Login with Google
          </Button>
          <Button onClick={signInWithMicrosoft} variant="inline-link" iconSvg={<TiVendorMicrosoft />}>
            Login with Microsoft
          </Button>
        </SpaceBetween>
      )}
      {userObject?.role === 'god' && (
        <div
          style={{
            paddingRight: 20,
            paddingTop: 50,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            gap: 8,
          }}
        >
          <Box variant="awsui-key-label">Change tenant</Box>
          <Select
            selectedOption={{
              value: tenant,
              label: tenants?.find((t) => t.name === tenant)?.displayName,
            }}
            options={tenants?.map((t) => {
              return {
                value: t.name,
                label: t.displayName,
              };
            })}
            onChange={({ detail }) => {
              changeTenant(detail.selectedOption.value ?? tenant);
              setDepartment('');
              refresh(3000);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Loginout;
